import { elt } from "../../../../lib/utils/browser";
function muteClick(e) {
  e.stopPropagation();
  e.preventDefault();
}
// eslint-disable-next-line @typescript-eslint/naming-convention
export let capturing = false;
let hoverTarget = null;
let highlightBox;
export function hoverHighlightRect(vue, flag = true) {
  var _vue$$el, _vue$$vnode, _vue$$el2;
  if (!flag && highlightBox) {
    window.document.body.removeChild(highlightBox);
    highlightBox = null;
    return;
  }
  if (!vue) return;
  const rect = (vue === null || vue === void 0 || (_vue$$el = vue.$el) === null || _vue$$el === void 0 ? void 0 : _vue$$el.getBoundingClientRect()) || null;
  const ref = (_vue$$vnode = vue.$vnode) === null || _vue$$vnode === void 0 || (_vue$$vnode = _vue$$vnode.data) === null || _vue$$vnode === void 0 ? void 0 : _vue$$vnode.ref;
  if (!rect) return;
  const {
    left,
    top,
    width,
    height
  } = rect;
  if (highlightBox) {
    window.document.body.removeChild(highlightBox);
  }
  highlightBox = window.document.createElement('div');
  highlightBox = elt('div', {
    class: 'ucd-hover-highlight-box',
    style: {
      left: `${left}px`,
      top: `${top}px`,
      width: `${width}px`,
      height: `${height}px`
    }
  }, [elt('span', {
    class: 'ucd-hover-highlight-box-text',
    style: {
      marginTop: `${((vue === null || vue === void 0 || (_vue$$el2 = vue.$el) === null || _vue$$el2 === void 0 || (_vue$$el2 = _vue$$el2.getBoundingClientRect()) === null || _vue$$el2 === void 0 ? void 0 : _vue$$el2.top) || 0) < 30 ? '0px' : '-23px'}`
    }
  }, [ref ? `#${ref}` : vue.$options.name || 'unknown'])]);
  window.document.body.appendChild(highlightBox);
  setTimeout(() => {
    if (highlightBox) highlightBox.style.opacity = '1';
  }, 50);
}
export default function startCapture({
  onHover,
  onCapture,
  designer
}) {
  var _designer$uc;
  if (capturing) return;
  capturing = true;
  const renderers = designer.scopeStack.map(scope => scope.renderer);
  renderers.push(designer === null || designer === void 0 || (_designer$uc = designer.uc) === null || _designer$uc === void 0 ? void 0 : _designer$uc.renderer);
  function hover(e) {
    var _target, _result$$vnode, _result$$vnode2;
    let {
      target
    } = e;
    const resultVue = [];
    while (target && !target.__vue__) {
      target = target.parentElement;
    }
    let vue = (_target = target) === null || _target === void 0 ? void 0 : _target.__vue__;
    while (vue) {
      var _vue$$vnode2;
      const vNodeData = (_vue$$vnode2 = vue.$vnode) === null || _vue$$vnode2 === void 0 ? void 0 : _vue$$vnode2.data;
      if (typeof (vNodeData === null || vNodeData === void 0 ? void 0 : vNodeData['uc:path']) === 'string') {
        const renderer = vNodeData['uc:renderer'];
        if (renderers.includes(renderer)) {
          resultVue.push(vue);
        }
      }
      vue = vue.$parent;
    }
    if (!resultVue.length) return;
    const result = resultVue[0];
    const scopedStack = [];
    let renderer = result === null || result === void 0 || (_result$$vnode = result.$vnode) === null || _result$$vnode === void 0 || (_result$$vnode = _result$$vnode.data) === null || _result$$vnode === void 0 ? void 0 : _result$$vnode['uc:renderer'];
    while (!!renderer) {
      scopedStack.push(renderer);
      renderer = renderer.parentScope;
    }
    const args = {
      path: (_result$$vnode2 = result.$vnode) === null || _result$$vnode2 === void 0 ? void 0 : _result$$vnode2.data['uc:path'],
      scopedStack
    };
    hoverHighlightRect(result, true);
    onHover === null || onHover === void 0 || onHover(e, args);
    hoverTarget = args;
  }
  function capture(e) {
    if (!hoverTarget) return;
    e.stopPropagation();
    e.preventDefault();
    onCapture === null || onCapture === void 0 || onCapture(e, hoverTarget);
    clearCapture();
  }
  const hoverFuncWithVue = e => hover(e);
  function clearCapture() {
    window.document.removeEventListener('click', capture, {
      capture: true
    });
    window.document.removeEventListener('mousedown', muteClick, {
      capture: true
    });
    window.document.removeEventListener('mouseup', muteClick, {
      capture: true
    });
    window.document.removeEventListener('mouseover', hoverFuncWithVue);
    if (highlightBox) {
      window.document.body.removeChild(highlightBox);
      highlightBox = null;
    }
    window.document.body.style.setProperty('cursor', 'auto', 'important');
    hoverTarget = null;
    capturing = false;
  }
  window.document.body.style.setProperty('cursor', 'crosshair', 'important');
  window.document.addEventListener('click', capture, {
    capture: true
  });
  window.document.addEventListener('mousedown', muteClick, {
    capture: true
  });
  window.document.addEventListener('mouseup', muteClick, {
    capture: true
  });
  window.document.addEventListener('mouseover', hoverFuncWithVue);
}
//# sourceMappingURL=captureComp.js.map
